import React from 'react';
import { Avatar, Typography, Button } from '@mui/material';
import Lottie from 'react-lottie';
import hangup from './gifLottie/hangup.json';
import $ from 'jquery';
export default function OutgoingCall({ onHangup }) {
    const optionsHangup = {
        loop: true,
        autoplay: true,
        animationData: hangup,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    // useEffect(() => {
    //      $('')
    // }, []);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4rem', marginTop: '18%' }}>
            <div style={{ transform: "rotate(130deg)" }}>
                <Lottie options={optionsHangup}
                    height={80}
                    width={80} />
            </div>
        </div>
    );
};

